<template lang="pug">
el-collapse-item(name='dadosTerritorio')
    template(slot='title')
        h2.collapse-titulo {{ $t('mensagens.territorio.territorioAr.titulo') }}

    .collapse-conteudo
        FormTerritorioAr(
            @update='onUpdate'
            @validate='onValidate'
            :cultivo='cultivo'
            :fields='fields'
            :mostrar-titulo='false'
        )
</template>

<script>
import FormTerritorioAr from '@/components/territorio/FormTerritorioAr.vue';

export default {
    name: 'FormTerritorio',
    components: {
        FormTerritorioAr
    },
    props: {
        cultivo: {
            type: Array,
            default: () => []
        },
        fields: {
            type: Object,
            default: () => ({})
        }
    },
    methods: {
        onUpdate(value) {
            const cloneValue = JSON.parse(JSON.stringify(value));
            const informacoesAgricolas = this.factoryInformacoesAgricolas(
                cloneValue.informacoesAgricolas
            );

            const newValue = {
                ...cloneValue,
                informacoesAgricolas
            };

            if (JSON.stringify(newValue) !== JSON.stringify(this._lastEmittedValue)) {
                this._lastEmittedValue = newValue;
                this.$emit('update', newValue);
            }
        },

        onValidate(value) {
            this.$emit('validate', value);
        },

        factoryInformacoesAgricolas(informacoesAgricolas) {
            return informacoesAgricolas.map(c => {
                const nome = this.cultivo.find(cultivo => cultivo.id === c.idCultura)?.nomeTraduzido;

                return {
                    idCultura: c.idCultura,
                    area: c.area,
                    media: c.media,
                    nome
                };
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.collapse-titulo {
    font-size: 16px;
    font-weight: bold;
    margin: 0;
    margin-left: 20px;
    color: #3b3b3b;
}

.collapse-conteudo {
    padding: 16px;
}
</style>
